import { post } from "../AxiosConfig";
import { withCache, requestCacheKey } from './profitabilityCache';
import { withDrawerRequest } from './drawerRequest';

const URI = "/terminal";

const listMachines = (payload) => {
  const URL = `${URI}/list-terminal`;
  return post(URL, payload);
};

const createMachine = (payload) => {
  const URL = `${URI}/create-terminal`;
  return post(URL, payload);
};

const updateMachine = (payload) => {
  const URL = `${URI}/update-terminal`;
  return post(URL, payload);
};

const deleteMachine = (payload) => {
  const URL = `${URI}/delete-terminal`;
  return post(URL, payload);
};

const getTerminal = (payload) => {
  const URL = `${URI}/get-terminals`;
  return post(URL, payload);
};

const getLocations = (payload) => {
  const URL = `${URI}/get-locations`;
  return post(URL, payload);
};

const getModems = (payload) => {
  const URL = `${URI}/get-modems`;
  return post(URL, payload);
};

const activateTerminal = (payload) => {
  const URL = `${URI}/activate-terminal`;
  return post(URL, payload);
};

const terminalList = withCache(
  (payload, config = {}) => post('/loadingterminal/loading-terminal-calculation', payload, config),
  payload => requestCacheKey('loadingTerminals', {
    companyId: Number(payload.companyId), employeeId: Number(payload.employeeId || 0),
    dateS: payload.dateS, sort: payload.sort || [{ value: 'loadingAmount', asc: false }], search: payload.search || '',
  }),
  15 * 1000,
);

const toAmountToLoad = (payload) => {
  const URL = `/loadingterminal/total-amount-to-load`;
  return post(URL, payload);
};

const updateLoadingTerminalData = (payload) => {
  const URL = `/loadingterminal/insert-loading-terminal-per-day-data`;
  return post(URL, payload);
};

const reCalculateLoadingTerminalData = (payload) => {
  const URL = `/loadingterminal/recalculate-loading-terminal`;
  return post(URL, payload);
};

const updateRowOrder = (payload) => {
  const URL = `/loadingterminal/enter-row-order-in-employee-to-location-map`;
  return post(URL, payload);
};

const getRemarks = (payload) => {
  const URL = `/remark/list-remarks`;
  return post(URL, payload);
};

const addRemarks = (payload) => {
  const URL = `/remark/insert-update-remarks`;
  return post(URL, payload);
};

// manageRowOrder הוסר (CR-35) — ה-endpoint נמחק; השתמשו ב-saveTempRowOrder

const manageCancelSubmitRowOrder = (payload) => {
  const URL = `/loadingterminal/update-row-status-for-terminal-calculation`;
  return post(URL, payload);
};

const cancelEmployeeLoading = (payload) => {
  const URL = `/loadingterminal/cancel-employee-loading`;
  return withDrawerRequest('cancel-employee-loading', payload, body => post(URL, body));
};

// ========== Row Order Management - New Functions ==========
// מחליפות את updateRowOrder הישנה (manageRowOrder הוסרה ב-CR-35)

const saveTempRowOrder = (payload) => {
  const URL = `/loadingterminal/save-temp-row-order`;
  return post(URL, payload);
};

const savePermanentRowOrder = (payload) => {
  const URL = `/loadingterminal/save-permanent-row-order`;
  return post(URL, payload);
};

const resetTempRowOrder = (payload) => {
  const URL = `/loadingterminal/reset-temp-row-order`;
  return post(URL, payload);
};

// ========== Alternative Loading Functions ==========

const alternativeLoadingCalculation = (payload) => {
  const URL = `/loadingterminal/alternative-loading-calculation`;
  return post(URL, payload);
};

const checkExistingCalculation = (payload) => {
  const URL = `/loadingterminal/check-existing-calculation`;
  return post(URL, payload);
};

const getEmployeeTerminals = (payload) => {
  const URL = `/loadingterminal/get-employee-terminals`;
  return post(URL, payload);
};

const getDayFraction = (payload) => {
  const URL = `/loadingterminal/get-day-fraction`;
  return post(URL, payload);
};

const MachineService = {
  listMachines,
  createMachine,
  updateMachine,
  deleteMachine,
  getTerminal,
  getLocations,
  getModems,
  activateTerminal,
  terminalList,
  toAmountToLoad,
  getRemarks,
  addRemarks,
  updateLoadingTerminalData,
  reCalculateLoadingTerminalData,
  updateRowOrder,  // deprecated - kept for backward compatibility
  manageCancelSubmitRowOrder,
  cancelEmployeeLoading,
  // New row order functions
  saveTempRowOrder,
  savePermanentRowOrder,
  resetTempRowOrder,
  // Alternative loading functions
  alternativeLoadingCalculation,
  checkExistingCalculation,
  getEmployeeTerminals,
  getDayFraction,
};

export default MachineService;
